import { Countries } from '../constants/data';

export const getCitiesByCountry = (country) => {
    return Countries.find((val) => val.name == country).cities;
};
